/**
 * Open a customer workspace in a separate standalone browser window.
 * TenantLayout exchanges the platform token for a sessionStorage-only
 * tenant-admin token in that window, leaving the original platform window and
 * its localStorage token untouched.
 */
export const openTenantAdminWorkspace = (tenantId, page = 'dashboard', search = '') => {
  if (!tenantId) return false;

  const cleanPage = String(page || 'dashboard').replace(/^\/+/, '');
  const query = search && String(search).startsWith('?') ? String(search) : '';
  const url = `/t/${encodeURIComponent(tenantId)}/${cleanPage}${query}`;
  const tenantWindow = window.open(
    url,
    '_blank',
    'popup=yes,noopener,noreferrer,width=1440,height=900,left=80,top=60,resizable=yes,scrollbars=yes'
  );
  if (!tenantWindow) {
    // window.open returns null when the browser's popup blocker steps in.
    // Callers here don't check the return value, so surface it directly
    // rather than failing silently with no workspace and no explanation.
    window.alert('Your browser blocked the tenant workspace popup. Please allow popups for this site and try again.');
    return false;
  }
  return true;
};

export default openTenantAdminWorkspace;
